export default function customEmailValidation (value: string):boolean {
  return (/^[A-Z0-9._+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i.test(value))
}
